import "./PolicyPages.css"

export default function CancellationRefund() {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Cancellation and Refund Policy</h1>
        <p className="last-updated">Last Updated: April 7, 2025</p>

        <section className="policy-section">
          <h2>1. Order Cancellation</h2>
          <p>
            We understand that circumstances may arise requiring you to cancel your order. Please review our
            cancellation policy below:
          </p>
          <ul>
            <li>
              <strong>Before Order Processing:</strong> Orders can be cancelled at no charge if the cancellation request
              is received before the order enters the processing stage.
            </li>
            <li>
              <strong>During Processing:</strong> Once an order has entered the processing stage, a cancellation fee of
              10% may apply.
            </li>
            <li>
              <strong>After Dispatch:</strong> Orders that have been dispatched cannot be cancelled. Please refer to our
              return policy instead.
            </li>
          </ul>
          <p>To cancel an order, please contact our customer service team immediately with your order number.</p>
        </section>

        <section className="policy-section">
          <h2>2. Refund Policy</h2>
          <p>
            We are committed to customer satisfaction. If you are not completely satisfied with your purchase, we offer
            the following refund options:
          </p>
          <ul>
            <li>
              <strong>Damaged or Defective Products:</strong> If you receive a damaged or defective product, we will
              provide a full refund or replacement at no additional cost.
            </li>
            <li>
              <strong>Incorrect Items:</strong> If you receive an item different from what you ordered, we will provide
              a full refund or send the correct item.
            </li>
            <li>
              <strong>Unsatisfactory Quality:</strong> If you are not satisfied with the quality of the product, you may
              return it within 7 days of receipt for a refund or exchange.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Return Process</h2>
          <p>To initiate a return:</p>
          <ol>
            <li>Contact our customer service team within 7 days of receiving your order.</li>
            <li>Provide your order number and reason for return.</li>
            <li>
              Our team will guide you through the return process and provide a return authorization if applicable.
            </li>
            <li>Return the item in its original packaging with all tags and accessories.</li>
          </ol>
          <p>
            Please note that certain items, such as perishable goods and custom-made products, are not eligible for
            return unless damaged or defective.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Refund Processing</h2>
          <p>Once we receive and inspect the returned item, we will process your refund as follows:</p>
          <ul>
            <li>Refunds will be issued to the original payment method used for the purchase.</li>
            <li>Processing time for refunds is typically 5-10 business days, depending on your payment provider.</li>
            <li>Shipping charges are non-refundable unless the return is due to our error.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Exceptions</h2>
          <p>The following items are not eligible for return or refund:</p>
          <ul>
            <li>Perishable goods such as food items, once delivered in good condition</li>
            <li>Custom-made or personalized products</li>
            <li>Digital products or downloadable items</li>
            <li>Items marked as final sale or clearance</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Contact Us</h2>
          <p>If you have any questions about our Cancellation and Refund Policy, please contact us at:</p>
          <p>
            Email: refunds@example.com
            <br />
            Phone: (123) 456-7890
          </p>
        </section>
      </div>
    </div>
  )
}

